import { render, staticRenderFns } from "./totalSales.vue?vue&type=template&id=6db4047a&scoped=true&"
import script from "./totalSales.vue?vue&type=script&lang=js&"
export * from "./totalSales.vue?vue&type=script&lang=js&"
import style0 from "./totalSales.vue?vue&type=style&index=0&id=6db4047a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4047a",
  null
  
)

export default component.exports